import {format} from "date-fns";

export const getScoreColor = (score) => {
    if (score >= 85) return 'text-[#002FA7]'; // Excellent - Primary Blue
    if (score >= 70) return 'text-[#009944]'; // Good - Success Green
    if (score >= 50) return 'text-[#FFB800]'; // Warning - Warning Yellow
    return 'text-[#D92D20]'; // Critical - Error Red
};

export const getScoreBg = (score) => {
    if (score >= 85) return 'bg-[#002FA7]/10';
    if (score >= 70) return 'bg-[#009944]/10';
    if (score >= 50) return 'bg-[#FFB800]/10';
    return 'bg-[#D92D20]/10';
};

export const getReadinessColor = (level) => {
    const colors = {
        'Highly Ready': 'text-[#002FA7] bg-[#002FA7]/10',
        'Ready': 'text-[#009944] bg-[#009944]/10',
        'Developing': 'text-[#FFB800] bg-[#FFB800]/10',
        'Not Ready': 'text-[#D92D20] bg-[#D92D20]/10'
    };
    return colors[level] || 'text-gray-600 bg-gray-100';
};

export const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-ZA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export const calculateMatchScore = (candidate, mentor) => {
    let score = 0;

    // Discipline match
    if (candidate.discipline === mentor.discipline) {
        score += 60;
    }

    // Experience level compatibility
    const expDiff = mentor.years_of_experience - candidate.years_of_experience;
    if (expDiff >= 5 && expDiff <= 15) {
        score += 30;
    } else if (expDiff > 0) {
        score += 10;
    }

    // Availability
    if (mentor.availability) {
        score += 10;
    }

    return Math.min(score, 100);
};

export const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

// export const formatDate = (date) => {
//     if (!date) return 'N/A';
//     try {
//         return format(date, 'PPP');
//     } catch {
//         return 'Invalid date';
//     }
// };
